import { render, staticRenderFns } from "./report-details.vue?vue&type=template&id=25a56efd&scoped=true"
import script from "./report-details.vue?vue&type=script&lang=js"
export * from "./report-details.vue?vue&type=script&lang=js"
import style0 from "./report-details.vue?vue&type=style&index=0&id=25a56efd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a56efd",
  null
  
)

export default component.exports